import { observer } from "mobx-react";
import { VBox } from "@/components-v2/Box";
import { RadioButtonGroup } from "@/components-v2/RadioButton";
import { identity } from "lodash";

import { useTranslation } from "@/stores/RootStoreContext";
import { BooleanFieldModel } from "@/common/commonForms";

export const IsDisposableAccount = observer(function ({
  isDisposableAccount,
  isProjectLocked,
}: {
  isDisposableAccount: BooleanFieldModel;
  isProjectLocked: boolean;
}) {
  const { t } = useTranslation();
  return (
    <VBox>
      <div>{t("decisions.increaseShareCapitalAgainstCash.payment.account.questionText")}</div>
      <RadioButtonGroup
        name={"isDisposableAccount"}
        options={[false, true]}
        idFn={identity}
        labelFn={(value) =>
          value
            ? t("decisions.increaseShareCapitalAgainstCash.payment.account.disposableAccount")
            : t("decisions.increaseShareCapitalAgainstCash.payment.account.nonDisposableAccount")
        }
        onChange={(_, option) => isDisposableAccount.setValue(option)}
        onBlur={() => isDisposableAccount.validate()}
        selected={isDisposableAccount.value}
        disabled={isProjectLocked}
      />
    </VBox>
  );
});
